import { render } from "./packagesMobileDropdown.vue?vue&type=template&id=1a210024&scoped=true"
import script from "./packagesMobileDropdown.vue?vue&type=script&lang=js"
export * from "./packagesMobileDropdown.vue?vue&type=script&lang=js"

import "./packagesMobileDropdown.vue?vue&type=style&index=0&id=1a210024&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a210024"]])

export default __exports__